import React from 'react';
import ReactDOM from 'react-dom/client';
import { QueryClientProvider } from '@tanstack/react-query';
import { App } from './App.js';
import { StandaloneMapPage } from './pages/StandaloneMapPage.js';
import { PublicAcademyPage } from './pages/PublicAcademyPage.js';
import { queryClient } from './lib/queryClient.js';
import { installMatomoSpaTracking } from './lib/matomoSpaTracking.js';
import { LocaleProvider } from './i18n/LocaleContext.js';
import './styles/globals.css';
import './styles/neon-cyberpunk.css';
import './styles/background-themes.css';
import './styles/night-ops.css';
import './styles/display-experience-engine.css';

installMatomoSpaTracking();

// Public, chrome-free live map — shareable link (#map or /map), no login.
function isMapRoute(): boolean {
  if (typeof window === 'undefined') return false;
  const hash = window.location.hash.replace(/^#\/?/, '').toLowerCase();
  const path = window.location.pathname.replace(/\/+$/, '').toLowerCase();
  return hash === 'map' || path.endsWith('/map');
}

function isAcademyRoute(): boolean {
  if (typeof window === 'undefined') return false;
  const hash = window.location.hash.replace(/^#\/?/, '').toLowerCase();
  const path = window.location.pathname.replace(/\/+$/, '').toLowerCase();
  return hash === 'academy' || path.endsWith('/academy');
}

const Root = isMapRoute()
  ? <StandaloneMapPage />
  : isAcademyRoute()
  ? <PublicAcademyPage />
  : <App />;

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <QueryClientProvider client={queryClient}>
      <LocaleProvider>
        {Root}
      </LocaleProvider>
    </QueryClientProvider>
  </React.StrictMode>,
);
